import {Component, Input, OnInit} from '@angular/core';
import {PlatformChart} from '@features/data-tracing/models/platform-chart.model';

@Component({
    standalone: false,
    selector: 'app-platform-donut-chart',
  templateUrl: './platform-donut-chart.component.html',
  styleUrl: './platform-donut-chart.component.scss'
})
export class PlatformDonutChartComponent implements OnInit {

  @Input() platformChart: PlatformChart;
  @Input() constantLabel: string;


  ngOnInit(): void {
    if (!this.platformChart?.holeSize) {
      this.platformChart.holeSize = 20;
    }
  }
}

